import { CustomUseQueryOptions } from '../types';
import { normalizeBaseTokenConfig } from '@/libs/sdk/api';
import type { ApiInstance, BaseTokenConfigApiResult } from '@/libs/sdk/api';
import { useQuery } from '@tanstack/react-query';

export const useBaseTokens = (api: ApiInstance, options?: CustomUseQueryOptions<BaseTokenConfigApiResult>) => {
  const { queryKey, ...rest } = options || {};
  return useQuery({
    ...rest,
    queryKey: [queryKey, 'BaseTokens'],
    queryFn: async () => {
      const { data } = await api.base.getBaseTokensConfig();
      // AIP backend returns a flat single token, not {baseTokens: [...]} —
      // without normalization the balance multicall saw no tokens and every
      // wallet balance rendered 0.
      return normalizeBaseTokenConfig(data);
    },
  });
};
